require.register("modules/m0x/a03/page-23-il-cc/page-23-il-cc", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_23_il_cc = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_23_il_cc;

  
});

